import es from '@/assets/lang/Spanish';
import pt from '@/assets/lang/Portuguese';
import en from '@/assets/lang/English';

import { getCookie } from '@/services/CookiesService';

export const defaultLocale = setLanguage();
export const languages = { pt, es, en };

export function setLanguage(lang?: string) {
  return !!lang !== false ? lang : getInitialLanguage();
}

function getInitialLanguage(langs: string[] = ['pt', 'es', 'en'], defaultLang: string = 'pt'): string {
  // Get prefered lag
  let lang: string = getCookie('language') || navigator.language || defaultLang;
  // normalizelang
  lang = lang.substr(0, 2).toLowerCase().replace('-', '_');

  if (langs.indexOf(lang) >= 0) return lang;
  else return defaultLang;
}
